import type { EvalAnnotationStatus } from "../../types";
import styles from "./AnnotationStatusBadge.module.css";

export interface AnnotationStatusBadgeProps {
  status?: EvalAnnotationStatus | string | null;
}

const STATUS_LABELS: Record<string, string> = {
  pending: "Pending",
  in_review: "In review",
  approved: "Approved",
  rejected: "Rejected",
  exported: "Exported",
};

export function AnnotationStatusBadge({ status }: AnnotationStatusBadgeProps) {
  if (!status) {
    return (
      <span className={styles.badge} data-status="none">
        None
      </span>
    );
  }

  const label = STATUS_LABELS[status] ?? status;

  return (
    <span className={styles.badge} data-status={status}>
      {label}
    </span>
  );
}
